/*
 * Copyright (c) 2024 Potentially Ltd
 *
 * Please see distribution for license
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToReadable',
})
export class CamelToReadablePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    const result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}
